import React, { useState } from 'react';
import './NewFacilityDetail.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WebLinkList from './WebLinkList';
import logComponent from '../../common/logComponent';

export default function NewFacilityDetail({ facility, linkToCorporation }) {

  if (logComponent('NewFacilityDetail')) { console.debug('NewFacilityDetail rendered'); }


  const handleCorporationClick = (e) => {
    if (logComponent('NewFacilityDetail')) { console.debug('NewFacilityDetail handleCorporationClick'); }
    const { corporationId } = e.currentTarget.dataset;

    // get facility based on id
    // NOTE: we want == in this case b/c the corporationId coming from the
    // dataset is a string, but the value in the linkedCorporations is a number
    const targetCorporation = facility.uiData.linkedCorporations.find(corporation => 
      corporation.salesforceAccountId &&
      corporation.salesforceAccountId == corporationId); // eslint-disable-line

    linkToCorporation(targetCorporation);
  }

    
  return (
    <div className="New-Facility-Detail">
      <h4 className="New-Facility-Detail__heading">{facility.name}</h4>
      <p className="New-Facility-Detail__instructions">Please accept or reject this new facility based on the information below.</p>
      <dl className="New-Facility-Detail__list">
        <dt>Facility Name</dt>
        <dd>
          {
            facility.name ||
            <span className="New-Facility-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>About Us</dt>
        <dd>
          {
            facility.aboutUs ||
            <span className="New-Facility-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>Postal Code</dt>
        <dd>
          {
            facility.postalCode ||
            <span className="New-Facility-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>Industry Type</dt>
        <dd>
          {
            facility.industryType ||
            <span className="New-Facility-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>Using SARA</dt>
        <dd>{facility.usingSara ? 'Yes' : 'No'}</dd>
        <dt>Using CATIE</dt>
        <dd>{facility.usingCatie ? 'Yes' : 'No'}</dd>
        <dt>Using EMessenger</dt>
        <dd>{facility.usingEMessenger ? 'Yes' : 'No'}</dd>
        <dt>Salesforce Site ID</dt>
        <dd>
          {
            facility.salesforceSiteId ||
            <span className="New-Facility-Detail__empty-field">Not Provided</span>
          }
        </dd>
        <dt>Salesforce Account ID</dt>
        <dd>
          {
            facility.salesforceAccountId ||
            <span className="New-Facility-Detail__empty-field">Not Provided</span>
          }
        </dd>
        <dt>Web Links</dt>
        <dd>
          {
            facility.webLinks.length === 0 ?
              <span className="New-Facility-Detail__empty-field">Not Provided</span> :
              <WebLinkList links={facility.webLinks} />
          }
        </dd>
        <dt>Linked Corporations</dt>
        <dd>
          {
            facility.uiData.linkedCorporations.length === 0 ?
              <span className="New-Facility-Detail__empty-field">None</span> :
              <ul className="New-Facility-Detail__corporation-list">
                {
                  facility.uiData.linkedCorporations.map(corporation =>
                    <li key={corporation.salesforceAccountId} className="New-Facility-Detail__corporation-item">
                      <span className="New-Facility-Detail__corporation-id">{corporation.salesforceAccountId}</span>
                      <span className="New-Facility-Detail__corporation-name">
                        {corporation.name}
                        {
                          (!corporation.status || corporation.status !== 'rejected') &&
                          <button
                            className="New-Facility-Detail__corporation-link"
                            data-corporation-id={corporation.salesforceAccountId}
                            onClick={handleCorporationClick}>
                            <FontAwesomeIcon icon="external-link-alt" />
                          </button>
                        }
                      </span>
                    </li>
                  )
                }
              </ul>
          }
        </dd>
      </dl>

    </div>
  );
}